import "./PlaygroundAnalyzingView.scss";
import Message from "../../../i18n/Message";

// Stagger for the vapour trails, fed to CSS as --i. The order is the original artwork's (outer
// trails lead, inner ones follow) and only decides which puff rises first.
const VAPOUR_STAGGER = [
  1, 2, 3, 19, 20, 4, 5, 6, 17, 18, 7, 8, 9, 15, 16, 10, 11, 12, 13, 14,
];

/**
 * The "we're building your playground" waiting state: the analysis copy plus the coffee cup.
 *
 * Shared by the creation dialog (both the plain and the post-OAuth resume path) and the playground
 * page, so the wait looks the same wherever the user happens to be watching it.
 *
 * `variant="page"` brings the dialog's dark backdrop along: the vapour is white, so the cup only
 * reads against a dark surface.
 */
const PlaygroundAnalyzingView = ({ variant = "dialog", timedOut = false }) => (
  <div className={"playground_analyzing_view " + variant}>
    <div className="analyzing_text">
      <Message
        id={
          timedOut
            ? "playground_analysis_taking_long"
            : "create_playground_analyzing_text"
        }
      />
    </div>
    <div>
      <div className="main-container">
        <div className="plate"></div>
        <div className="cup">
          <div className="top">
            <div className="vapour">
              {VAPOUR_STAGGER.map((i, index) => (
                <span key={index} style={{ "--i": String(i) }}></span>
              ))}
            </div>
            <div className="circle">
              <div className="coffee"></div>
            </div>
          </div>
          <div className="handle"></div>
        </div>
      </div>
    </div>
  </div>
);

export default PlaygroundAnalyzingView;
